module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1023.1f7e0e9b.png";